import { render } from "./CookiesNumberInput.vue?vue&type=template&id=170caa36&scoped=true"
import script from "./CookiesNumberInput.vue?vue&type=script&lang=js"
export * from "./CookiesNumberInput.vue?vue&type=script&lang=js"

import "./CookiesNumberInput.vue?vue&type=style&index=0&id=170caa36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170caa36"]])

export default __exports__